import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../redux/store';
import { getAllApplicationUsers } from '../reducers/getAllUsers';

const useGetAllUsers = (): {
  loading: boolean;
  error: unknown;
} => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>();

  const getApplicationUsers = async () => {
    try {
      const resultAction = await dispatch(getAllApplicationUsers());
      if (getAllApplicationUsers.fulfilled.match(resultAction)) {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setError(error);
    }finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    getApplicationUsers();
  }, []);

  return { loading, error };
};

export default useGetAllUsers;
